import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { Router, browserHistory, Route, Redirect } from 'react-router';
import AppFront from './front/AppFront';
import NotFound from './front/NotFound';
import Arcplan from './components/Arcplan';
import Arcplan2 from './components/Arcplan2';
import ConnectedAs from './components/ConnectedAs';
import LinkPartners from './module/Partnership/LinkPartners';
import Partner from './module/Partner/Partner';
import Documentation from './module/Documentation/containers/Documentation';
import OuiLink from './module/OuiLink/containers/OuiLink';
import GenerateFiskTokenPage from './module/Fisc/containers/GenerateFiscTokenPage';
import FiscAccountAccessPage from './module/Fisc/containers/FiscAccountAccessPage';
import DetailsCloture from './module/Fisc/containers/DetailsCloture';
import DetailsService from './module/Fisc/containers/DetailsService';
import DetailsCommande from './module/Fisc/containers/DetailsCommande';
import ErrorsPage from './module/Fisc/containers/ErrorsPage';
import FiscPage from './module/Fisc/containers/FiscPage';
import requireAuth from './utils/requireAuth';
import Migration from './module/AccountMigration/Migration';
import Video from './module/Video/containers/Video';
import TechnicalIntervention from './module/Fisc/containers/TechnicalIntervention';
import EmailValidation from './module/AccountMigration/EmailValidation';
import MigrationStep1 from './module/AccountMigration/MigrationStep1';
import DetailsMvtCaisse from './module/Fisc/containers/DetailsMvtCaisse';
import DetailsOrderLines from './module/Fisc/containers/DetailsOrderLines';
import DetailsReceipt from './module/Fisc/containers/DetailsReceipt';
import DetailsPaymentLines from './module/Fisc/containers/DetailsPaymentLines';
import DetailsCredit from './module/Fisc/containers/DetailsCredit';
import DetailsError from './module/Fisc/containers/DetailsError';
import FAQ from './module/FAQ/containers/FAQ';
import CustomerAccount from './module/CustomerAccount/containers/CustomerAccount';
import CustomerAccountDetails from './module/CustomerAccount/containers/CustomerAccountDetails';
import DocSlite from './components/DocSlite';
import BarDistrib from './module/BarDistrib/containers/BarDistrib';
import DataExport from './module/DataExport/containers/DataExport';
import FeedContainer from './common/Feed/FeedContainer';
import Maintenance from './components/Maintenance/Maintenance';
import ExportVat from './module/ExportVat/containers/ExportVat';
import SuiteVideos from './module/SuiteVideos/containers/SuiteVideos';
import ControlStrip from './module/ControlStrip/containers/ControlStrip';
import ShiftDetails from './module/ShiftDetails/containers/ShiftDetails';
import { UnauthorizedServicePage } from '@capps/subuser-tools';
import Settings from './module/Settings/containers/Settings';
import Weekdays from './module/Weekdays/containers/Weekdays';
import SalesAnalysis from './module/SalesAnalysis/containers/SalesAnalysis';
import Stock from './module/Stock/containers';
import Receipts from './module/Receipts/containers';
import VatPerFamily from './module/VatPerFamily/containers';
import FamilyManager from './module/FamilyManager/containers';
import Download from './module/Download/containers/Download';
import Pms from './module/Pms/containers/Pms';
import WaiterSales from './module/WaiterSales/containers/WaiterSales';
import SalesByFloor from './module/SalesByFloor/containers/SalesByFloor';
import MenuExtract from './module/MenuExtract/containers/MenuExtract';
import ZDigital from './module/ZDigital/containers/ZDigital';
import CashMovement from './module/CashMovement/containers/CashMovement';
import TicketRestaurant from './module/TicketRestaurant/containers/TicketRestaurant';
import CustomerAccountVat from './module/CustomerAccountVat/containers/CustomerAccountVat';
import EstablishmentComparison from './module/EstablishmentComparison/containers/EstablishmentComparison';
import PeriodComparison from './module/PeriodComparison/containers/PeriodComparison';
import CustomTurnoverGuest from './module/CustomTurnoverGuest/containers/CustomTurnoverGuest';
import CustomPoloCompta from './module/CustomPoloCompta/containers/CustomPoloCompta';
import CustomFloorsIndiana from './module/CustomFloorsIndiana/containers/CustomFloorsIndiana';
import CustomExporterIndiana from './module/CustomExporterIndiana/containers/CustomExporterIndiana';
import CustomExportSalesProductRatio from './module/CustomExportSalesProductRatio/containers/CustomExportSalesProductRatio';
import CustomProductDetails from './module/CustomProductDetails/containers/CustomProductDetails';
import CustomMultiSummary from './module/CustomMultiSummary/containers/CustomMultiSummary';
import CustomHourlyIndiana from './module/CustomHourlyIndiana/containers/CustomHourlyIndiana';
import CustomExportArevian from './module/CustomExportArevian/containers/CustomExportArevian';
import CustomExportYellow from './module/CustomExportYellow/containers/CustomExportYellow';
import CustomExportBdo from './module/CustomExportBdo/containers/CustomExportBdo';
import CustomExportBonbo from './module/CustomExportBonbo/containers/CustomExportBonbo';
import CustomSalesExport from './module/CustomSalesExport/containers/CustomSalesExport';
import CustomCustomerAccountExport from './module/CustomCustomerAccountExport/containers/CustomCustomerAccountExport';
import CancelsAnalysis from './module/CancelsAnalysis/containers/CancelsAnalysis';
import CustomersAnalysis from './module/CustomersAnalysis/containers/CustomersAnalysis';
import CustomInExtenso from './module/CustomInExtenso/containers/CustomInExtenso';
import CustomExportBellevilloise from './module/CustomExportBellevilloise/containers/CustomExportBellevilloise';
import SalesPrediction from './module/SalesPrediction/containers/SalesPrediction';
// import ReportContainer from './module/Reports/containers/ReportsContainer';
// import BookingsReport from './module/Reports/containers/BookingsReport';

const Root = ({ store, logPageView }) => (
	<Provider store={store}>
		<Router history={browserHistory} onUpdate={logPageView}>
			<Route
				path="/"
				component={AppFront}
				onEnter={(nextState, replace, next) => {
					requireAuth(store, nextState, replace, next);
				}}
				onChange={(prevState, nextState, replace, next) => {
					requireAuth(store, nextState, replace, next);
				}}>
				<Route path="reporting/:reportName" component={Arcplan} />
				<Route path="reporting-sales/:reportName" component={Arcplan2} />
				<Route path="videos" component={Video} />
				<Route path="videos-suite" component={SuiteVideos} />
				<Route path="connect-as/:viewAsCustomerToken" component={ConnectedAs} />
				<Route
					path="FAQ"
					component={FAQ}
					onEnter={(nextState, replace, next) => {
						requireAuth(store, nextState, replace, next);
					}}
					onChange={(prevState, nextState, replace, next) => {
						requireAuth(store, nextState, replace, next);
					}}
				/>
				<Route path="documentation" component={Documentation} />
				<Route path="ouilink" component={OuiLink} />
				<Route path="partenaires" component={Partner} />
				<Route path="doc" component={DocSlite} />
				<Route
					path="generate-connexion-token"
					component={GenerateFiskTokenPage}
				/>
				<Route path="fisc-connect-as" component={FiscAccountAccessPage} />
				<Route exact path="administration-fiscale" component={FiscPage} />
				<Route path="administration-fiscale/errors" component={ErrorsPage} />
				<Route
					path="administration-fiscale/errors/details/:id"
					component={DetailsError}
				/>
				<Route
					path="administration-fiscale/clotures/details/:id"
					component={DetailsCloture}
				/>
				<Route
					path="administration-fiscale/services/details/:id"
					component={DetailsService}
				/>
				<Route
					path="administration-fiscale/commandes/details/:id"
					component={DetailsCommande}
				/>
				<Route
					path="administration-fiscale/mvtcaisse/details/:id"
					component={DetailsMvtCaisse}
				/>
				<Route
					path="administration-fiscale/orderlines/details/:id"
					component={DetailsOrderLines}
				/>
				<Route
					path="administration-fiscale/receipt/details/:id"
					component={DetailsReceipt}
				/>
				<Route
					path="administration-fiscale/paymentlines/details/:id"
					component={DetailsPaymentLines}
				/>
				<Route
					path="administration-fiscale/credit/details/:id"
					component={DetailsCredit}
				/>
				<Route
					path="administration-fiscale/technical-intervention"
					component={TechnicalIntervention}
				/>
				<Route path="partnership" component={LinkPartners} />
				<Route
					path="account/migration"
					component={Migration}
					onEnter={(nextState, replace, next) => {
						requireAuth(store, nextState, replace, next);
					}}
					onChange={(prevState, nextState, replace, next) => {
						requireAuth(store, nextState, replace, next);
					}}
				/>{' '}
				{/*<Route path={'maintenance-info'} component={FeedContainer} />*/}
				<Route path={'feed/:name'} component={FeedContainer} />
				<Route path={'account/migration/step-1'} component={MigrationStep1} />
				<Route path="check-new-email" component={EmailValidation} />
				<Route path="customer-account" component={CustomerAccount} />
				<Route path="customer-account/:id" component={CustomerAccountDetails} />
				<Route path="warelist" component={BarDistrib} />
				<Route path="export-data" component={DataExport} />
				<Route path="export-vat" component={ExportVat} />
				<Route path="unauthorized" component={UnauthorizedServicePage} />
				{/*<Route*/}
				{/*path='report/'*/}
				{/*component={ReportContainer}*/}
				{/*>*/}
				{/*<Route*/}
				{/*path='booking'*/}
				{/*component={BookingsReport}*/}
				{/*/>*/}
				{/*</Route>*/}
				<Route path="v2/control-strip" component={ControlStrip} />
				<Route path="v2/shift-details" component={ShiftDetails} />
				<Route path="v2/settings" component={Settings} />
				<Route path="v2/weekdays-details" component={Weekdays} />
				<Route path="v2/sales-analysis" component={SalesAnalysis} />
				<Route path="v2/stock" component={Stock} />
				<Route path="v2/receipts" component={Receipts} />
				<Route path="v2/vat-family" component={VatPerFamily} />
				<Route path="v2/family-manager" component={FamilyManager} />
				<Route path="v2/download" component={Download} />
				<Route path="v2/pms" component={Pms} />
				<Route path="v2/waiter-sales" component={WaiterSales} />
				<Route path="v2/sales-by-floor" component={SalesByFloor} />
				<Route path="v2/menu-extract" component={MenuExtract} />
				<Route path="v2/z-digital" component={ZDigital} />
				<Route path="v2/cash-movement" component={CashMovement} />
				<Route path="v2/ticket-restaurant" component={TicketRestaurant} />
				<Route path="v2/customer-account-vat" component={CustomerAccountVat} />
				<Route path="v2/establishment-comparison" component={EstablishmentComparison} />
				<Route path="v2/period-comparison" component={PeriodComparison} />
				<Route path="v2/custom-turnover-guest" component={CustomTurnoverGuest} />
				<Route path="v2/custom-polo-compta" component={CustomPoloCompta} />
				<Route path="v2/custom-floors-indiana" component={CustomFloorsIndiana} />
				<Route path="v2/custom-exporter-indiana" component={CustomExporterIndiana} />
				<Route path="v2/custom-export-sales-product-ratio" component={CustomExportSalesProductRatio} />
				<Route path="v2/custom-product-details" component={CustomProductDetails} />
				<Route path="v2/custom-multi-summary" component={CustomMultiSummary} />
				<Route path="v2/custom-hourly-indiana" component={CustomHourlyIndiana} />
				<Route path="v2/custom-export-arevian" component={CustomExportArevian} />
				<Route path="v2/custom-export-yellow" component={CustomExportYellow} />
				<Route path="v2/custom-export-bdo" component={CustomExportBdo} />
				<Route path="v2/custom-export-bonbo" component={CustomExportBonbo} />
				<Route path="v2/custom-sales-export" component={CustomSalesExport} />
				<Route path="v2/custom-customer-account-export" component={CustomCustomerAccountExport} />
				<Route path="v2/cancels-analysis" component={CancelsAnalysis} />
				<Route path="v2/customers-analysis" component={CustomersAnalysis} />
				<Route path="v2/custom-in-extenso" component={CustomInExtenso} />
				<Route path="v2/custom-export-bellevilloise" component={CustomExportBellevilloise} />
				<Route path="v2/sales-prediction" component={SalesPrediction} />
				{/* On les garde juste par rétrocompatibilité*/}
				<Redirect from="reporting-v2/control-strip" to="v2/control-strip" />
				<Redirect from="reporting-v2/shift-details" to="v2/shift-details" />
				<Redirect from="reporting-v2/settings" to="v2/settings" />
				<Redirect
					from="reporting-v2/weekdays-details"
					to="v2/weekdays-details"
				/>
				<Route path="*" component={NotFound} />
			</Route>
		</Router>
	</Provider>
);

Root.propTypes = {
	store: PropTypes.object.isRequired,
};

export default Root;
